import { founder } from '../../data/content';
import type { ArticleBlock as Block } from '../../core/types/content';

/** Eén blok uit de artikeltekst: alinea, tussenkop, lijst of tip. */
export function ArticleBlock({
  block
}: {
  block: Block;
}) {
  switch (block.type) {
    case 'h':
      return <h2 className="mt-12 type-title text-ink first:mt-0" data-id="element-7857" data-mp="16kserbscqq1g">{block.text}</h2>;
    case 'list':
      return <ul className="mt-5 space-y-2.5 border-l border-line pl-5" data-id="element-7858" data-mp="1z73giprp2wzu">
          {block.items.map((item, i) => <li key={`${i}-${item}`} className="text-[17px] leading-relaxed text-ink" data-id="element-7859" data-mp="23985hb7775g5" data-mpi={i}>
              {item}
            </li>)}
        </ul>;
    case 'tip':
      return <aside className="mt-8 bg-shell px-6 py-5 text-[17px] leading-relaxed text-ink" aria-label={`Tip van ${founder.firstName}`} data-id="element-7860" data-mp="1ug4vjcvrhaq9">
          <span className="italic text-clay" aria-hidden="true" data-id="element-7861" data-mp="2i4xsnco4domg">
            Tip van {founder.firstName} —{' '}
          </span>
          {block.text}
        </aside>;
    case 'p':
      return <p className="mt-5 text-[17px] leading-[1.75] text-ink/85 first:mt-0" data-id="element-7862" data-mp="2t0l52jtialno">{block.text}</p>;
  }
}